import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home'
import NavigationLayout from './components/NavigationLayout/NavigationLayout'
import TrainingLanding from './pages/TrainingLanding';
import TrainingStepPage from './pages/TrainingStep';

const App: React.FC = () => {

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path='/' element={<NavigationLayout />}>
          <Route index element={<Home />} />
          <Route path='/training' element={<TrainingLanding />} />
          <Route path='/module' element={<TrainingStepPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
